import React from "react";
import Styles from "./ConfirmModalContainer.module.scss";
import { Modal, Space, Text, Button } from "react_reusable_components";
import variables from "../../themes/base/styles/variables";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import { useIntl } from "react-intl";

const confirmModalStyles = {
  changed: {
    fontSize: variables.fontSizeXlarge,
    fontWeight: variables.fontWeightBold,
  },
  changedSuccess: {
    fontSize: variables.fontSizeXlarge,
    fontWeight: variables.fontWeightBold,
    textAlign: variables.alignCenter,
    color: variables.textDefault,
    lineHeight: variables.lineHeightXxlarge,
    display: variables.dBlock,
  },
  BlockButton: {
    fontSize: variables.fontSizeSmall,
    fontWeight: variables.fontWeightNormal,
    lineHeight: variables.lineHeightNormal,
    flex: 1,
    backgroundColor: variables.successGreen,
  },
  CancelButton: {
    fontSize: variables.fontSizeSmall,
    fontWeight: variables.fontWeightNormal,
    lineHeight: variables.lineHeightNormal,
    flex: 1,
    border: `1px solid ${variables.grey4}`,
  },
  modalContent: {
    all: variables.unset,
    width: variables.fullWidth,
  },
  modalMaskStyle: {
    backdropFilter: variables.highBlur,
    background: variables.blurBackground,
  },
  btnContainer: {
    display: variables.dFlex,
    gap: variables.gapSmall,
  },
  textarea: { width: variables.fullWidth, padding: variables.paddingSmallest },
  centerImg: {
    display: variables.dFlex,
    justifyContent: variables.alignCenter,
    position: "relative",
  },
  cross: {
    position: "absolute",
    right: "0",
    top: "0",
    height: variables.iconHeightLarge,
    width: variables.iconWidthLarge,
    cursor: "pointer",
  },
  questionDescriptionStyle: {
    fontSize: variables.fontSizeSmall,
    fontWeight: variables.fontWeightNormal,
    lineHeight: variables.lineHeightMedium,
    textAlign: "center",
    color: variables.grey1,
    display: variables.dFlex,
    flexDirection: "column",
  },
};

export default function ConfirmModalContainer({
  open,
  setOpen,
  onClose = () => {}, //NOSONAR
  iconSrc,
  question,
  onConfirm = () => {}, //NOSONAR
  onCancel = () => {}, //NOSONAR
  descriptionText,
  restStyle,
  cancelText,
  confirmText,
  hideButton,
  hideCloseButton,
  isCancelBtn = true,
  closeInternally = true,
}) {
  const intl = useIntl();
  return (
    <Modal
      maskClosable={false}
      maskStyle={confirmModalStyles.modalMaskStyle}
      className={Styles["edged-modal"]}
      centered
      open={open}
      closable={false}
      footer={null}
      width={400}
    >
      <Space
        direction="vertical"
        align="center"
        style={confirmModalStyles.modalContent}
      >
        <div style={confirmModalStyles.centerImg}>
          {iconSrc && <img src={iconSrc} alt="block-user" />}
          {!hideCloseButton && (
            <img
              style={confirmModalStyles.cross}
              src={"/icons/close.svg"}
              alt="block-user"
              onClick={() => {
                onClose();
                setOpen(false);
              }}
            />
          )}
        </div>
        <Text style={confirmModalStyles.changedSuccess}>{question}</Text>
        {descriptionText && (
          <Text style={confirmModalStyles.questionDescriptionStyle}>
            {descriptionText}
          </Text>
        )}

        {!hideButton && (
          <div style={confirmModalStyles.btnContainer}>
            {isCancelBtn && (
              <Button
                style={confirmModalStyles.CancelButton}
                icon={null}
                type="text"
                onClick={() => {
                  onCancel();
                  setOpen(false);
                }}
              >
                {cancelText || getLocalizedMessage(intl, "button.text.cancel")}
              </Button>
            )}
            <Button
              style={{ ...confirmModalStyles.BlockButton, ...restStyle }}
              icon={null}
              onClick={() => {
                closeInternally && setOpen(false);
                onConfirm?.();
              }}
            >
              {confirmText || getLocalizedMessage(intl, "login.button.confirm")}
            </Button>
          </div>
        )}
      </Space>
    </Modal>
  );
}
